var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-var, object-curly-spacing, react/jsx-closing-bracket-location, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var Editor = require("../editor.jsx");
var InfoTip = require("../components/info-tip.jsx");
var PropCheckBox = require("../components/prop-check-box.jsx");

var PassageEditor = React.createClass({
    displayName: "PassageEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        passageTitle: React.PropTypes.string,
        passageText: React.PropTypes.string,
        footnotes: React.PropTypes.string,
        showLineNumbers: React.PropTypes.bool
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            passageTitle: "",
            passageText: "",
            footnotes: "",
            showLineNumbers: true
        };
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    render: function render() {
        var _this = this;

        var passageEditor = React.createElement(Editor, {
            ref: "passage-editor",
            apiOptions: this.props.apiOptions,
            content: this.props.passageText,
            widgetEnabled: false,
            placeholder: "Type passage here...",
            onChange: function onChange(newProps) {
                _this.change({ passageText: newProps.content });
            },
            showWordCount: true
        });
        var footnotesEditor = React.createElement(Editor, {
            ref: "passage-footnotes-editor",
            apiOptions: this.props.apiOptions,
            content: this.props.footnotes,
            widgetEnabled: false,
            placeholder: "Type footnotes here...",
            onChange: function onChange(newProps) {
                _this.change({ footnotes: newProps.content });
            }
        });
        return React.createElement(
            "div",
            { className: "perseus-widget-passage-editor" },
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(PropCheckBox, {
                    label: "Show line numbers",
                    labelAlignment: "right",
                    showLineNumbers: this.props.showLineNumbers,
                    onChange: this.props.onChange
                })
            ),
            React.createElement(
                "div",
                null,
                "Passage title:",
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "An optional title that will appear directly above the passage in the same font style. (E.g. Passage 1)"
                    )
                ),
                React.createElement(
                    "div",
                    null,
                    React.createElement("input", {
                        type: "text",
                        defaultValue: this.props.passageTitle,
                        onChange: function onChange(e) {
                            _this.change({ passageTitle: e.target.value });
                        }
                    })
                )
            ),
            React.createElement(
                "div",
                null,
                "Passage Text:",
                passageEditor
            ),
            React.createElement(
                "div",
                null,
                "Footnotes:",
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "To add footnotes, add ^ characters where they belong in the passage. Then, add ^ in the footnotes area to reference the footnotes in the passage."
                    )
                ),
                footnotesEditor
            )
        );
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = PassageEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/passage-editor.jsx
 ** module id = 135
 ** module chunks = 0 1
 **/